import { Auth } from '../app/models/Auth';

/**
 * Verifica si el usuario tiene un permiso específico
 * @param auth - Objeto de autenticación del usuario
 * @param permission - Nombre del permiso a verificar
 * @returns true si el usuario tiene el permiso, false en caso contrario
 */
export const hasPermission = (auth: Auth | null, permission: string): boolean => {
    if (!auth) return false;
    
    // Si tiene todos los permisos, retornar true
    if (auth.hasAllPermissions) return true;
    
    // Verificar si el permiso está en la lista de permisos del usuario
    return auth.permissions?.includes(permission) || false;
};

/**
 * Verifica si el usuario tiene al menos uno de los permisos especificados
 * @param auth - Objeto de autenticación del usuario
 * @param permissions - Array de permisos a verificar
 * @returns true si el usuario tiene al menos uno de los permisos, false en caso contrario
 */
export const hasAnyPermission = (auth: Auth | null, permissions: string[]): boolean => {
    if (!auth) return false;
    
    // Si tiene todos los permisos, retornar true
    if (auth.hasAllPermissions) return true;
    
    // Verificar si al menos uno de los permisos está en la lista
    return permissions.some(permission => auth.permissions?.includes(permission)) || false;
};

/**
 * Verifica si el usuario tiene todos los permisos especificados
 * @param auth - Objeto de autenticación del usuario
 * @param permissions - Array de permisos a verificar
 * @returns true si el usuario tiene todos los permisos, false en caso contrario
 */
export const hasAllPermissions = (auth: Auth | null, permissions: string[]): boolean => {
    if (!auth) return false;
    
    // Si tiene todos los permisos, retornar true
    if (auth.hasAllPermissions) return true;
    
    // Verificar si todos los permisos están en la lista
    return permissions.every(permission => auth.permissions?.includes(permission)) || false;
};

/**
 * Verifica si el usuario tiene un rol específico
 * @param auth - Objeto de autenticación del usuario
 * @param role - Nombre del rol a verificar
 * @returns true si el usuario tiene el rol, false en caso contrario
 */
export const hasRole = (auth: Auth | null, role: string): boolean => {
    if (!auth) return false;
    
    return auth.roles?.includes(role) || false;
};
